<template>
  <div class="yxtbiz-multi-class-audit font-size-16 font-bolder color-gray-10" v-loading="loading">
    {{ tip }}
    <br />
    {{ $t('pc_biz_multi_class_tip2' /* 请您确认是否同意此次安排。*/) }}
  </div>
</template>

<script>
import { getAuditDetail } from './service';
export default {
  name: 'YxtbizMultiClassAudit',
  name_zh: '多班次申请加入审核',
  props: {
    formId: {
      type: String,
      required: true,
      default: '',
      desc: '审核 FormID',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      loading: false,
      auditDetail: {}
    };
  },
  computed: {
    tip() {
      const {stuFullName, subTaskIndex, subTaskName, subTaskType} = this.auditDetail;
      const taskTypeMap = {
        1: this.$t('pc_biz_o2o_lbl_facetoface' /* 面授 */),
        2: this.$t('pc_biz_o2o_lbl_exam' /* 考试 */),
        17: this.$t('pc_biz_o2o_lbl_live' /* 直播 */)
      };
      return this.$t('pc_biz_multi_class_tip1', [stuFullName, taskTypeMap[subTaskType], subTaskIndex, subTaskName]);
    }
  },
  created() {
    this.fetchAuditDetail();
  },
  methods: {
    fetchAuditDetail() {
      this.loading = true;
      getAuditDetail(this.formId).then(data => {
        this.auditDetail = data;
      })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
